import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children, allowedAuthority, disallowedAuthority, requiredCompanyId }) => {
  const token = localStorage.getItem('accessToken');
  const user = useSelector((state) => state.login.user);
  const authorityClass = user?.authority_class;
  const isManagementCompany = user?.management;
  const location = useLocation();

  if (!token) {
    const lastAction = localStorage.getItem('lastAction');
    if (lastAction !== 'logout') {
      const redirectPath = location.pathname + location.search;
      localStorage.setItem("redirectAfterLogin", redirectPath);
    }
    return <Navigate to="/login" replace />;
  }

  if (user && (
      (allowedAuthority && authorityClass !== allowedAuthority) || 
      (disallowedAuthority === authorityClass) || 
      (requiredCompanyId && isManagementCompany !== requiredCompanyId)
    )) {
    alert("アクセス権限がありません。");
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
